<template>
    <div>
        <!--loader - message--->
        <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
        <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
        <div class="clientProfile">
			<div class="mt-2 middleBox" v-if="(trans_id != '')"> 
					<app-OptVerfication :transaction_id="trans_id" :module="'16'" :title_parent="Title" :data="''" :ticketRequestFrom="'profileOtp'" :accountId="''"></app-OptVerfication>
			</div>
            <div class="middleBox whiteBG p-4" v-if="getUserProfile != '' && trans_id == ''">
                <div class="prifleName d-flex align-items-center mb-3 border-bottom pb-3">
                    <div class="ico mr-3" v-if="getUserProfile.firstname">
                        {{getUserProfile.firstname.charAt(0)}}{{getUserProfile.lastname.charAt(0)}}
                    </div>
                    <div class="ico mr-3" v-else>{{getUserProfile.email.charAt(0)}}</div>
                    <div class="w-100">
                        <h3>{{getUserProfile.firstname}} {{getUserProfile.lastname}}</h3>
                        <div class="user_verification">
                            <span class="user_verified" v-if="parseInt(get_user.verified_status) == 1"> {{$t('prof_verified')}}</span>
                            <div class="verifiedStatus d-flex justify-content-between align-items-center" v-else-if="parseInt(get_user.step) == 3 && parseInt(get_user.verified_status) != 1">
                                <div>
                                    <h4 class="mb-0 Application">{{$t('prof_undrreview')}}</h4>
                                    <p class="mb-0">{{$t('prof_checkstatus')}}</p> 
                                </div>
                                <div class="d-flex justify-content-end"> 
                                    <a href="" @click.prevent="redirect()" class="common_btn btn_sm">{{$t('prof_clickhere')}}</a> 
                                </div>
                            </div>
                            <span class="not_verifieds" v-else>  
                                <router-link :to="stepPageOpenFunc(get_user.step)" class="prism_btn redBG btn_sm lift">{{$t('prof_completeRegister')}}</router-link>
                            </span>
                        </div>
                    </div>
                </div> 
                <div class=" TabNav" >
                    <div class="tab-nav border-0 d-flex align-items-center mb-3">
                        <ul class="d-flex align-items-center profileTabs">
                            <li :class="(tab == 'basic')?'active' : ''"><a href="#" @click.prevent="tab = 'basic'" >  {{$t('prof_basicDetail')}}</a></li>
                            <li :class="(tab == 'address')?'active' : ''"><a href="#" @click.prevent="tab = 'address'" > {{$t('prof_addressDetail')}}</a></li>
                            <li :class="(tab == 'bank')?'active' : ''"><a href="#" @click.prevent="tab = 'bank'" >{{$t('prof_paymentDetail')}}</a></li> 
                            <li :class="(tab == 'doc')?'active' : ''"><a href="#" @click.prevent="tab = 'doc'" > {{$t('prof_documents')}}</a></li> 
                            <li :class="(tab == 'trading')?'active' : ''"><a href="#" @click.prevent="tab = 'trading'" > Trading Account </a></li> 
                        </ul>  
                    </div>   
                    <div class="TabContent-area" >
                        <div class="personalFormArea " v-if="tab == 'basic'"> 
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_fname')}}</span>
                                        <span>{{getUserProfile.firstname || '-'}}</span>
                                    </div>
                                </div> 
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_lname')}}</span>
                                        <span>{{getUserProfile.lastname || '-'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">{{$t('prof_DOB')}}</span>
                                        <span v-if="getUserProfile.dob && getUserProfile.dob != '0000-00-00'">{{getUserProfile.dob | moment('Do MMMM YYYY')}}</span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_phone')}}</span>
                                        <span>{{getUserProfile.mobile_no || '-'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_user.account_type) == 1">
                                <div class="row mb-3 no-gutters">
                                    <div class="col-md-6 pr-2 pl-0">
                                        <div class="list-group-item">
                                            <span class="Fname d-block light-p">{{$t('prof_Member')}} {{$t('prof_fname')}}</span>
                                            <span>{{getUserProfile.member_fname || '-'}}</span>
                                        </div>
                                    </div> 
                                    <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                        <div class="list-group-item">
                                            <span class="Fname d-block light-p">{{$t('prof_Member')}} {{$t('prof_lname')}}</span>
                                            <span>{{getUserProfile.member_lname || '-'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3 no-gutters">
                                    <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                        <div class="list-group-item">
                                            <span class="Fname d-block light-p">{{$t('prof_Member')}} {{$t('prof_DOB')}}</span>
                                            <span v-if="getUserProfile.member_dob && getUserProfile.member_dob != '0000-00-00'">{{getUserProfile.member_dob | moment('Do MMMM YYYY')}}</span>
                                            <span v-else>-</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 no-gutters" v-if="parseInt(get_user.account_type) == 2">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">{{$t('prof_companyname')}}</span>
                                        <span>{{getUserProfile.company_name || '-'}}</span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">{{$t('prof_incorporationdate')}}</span>
                                        <span v-if="getUserProfile.incorporation_date && getUserProfile.incorporation_date != '0000-00-00'">{{getUserProfile.incorporation_date | moment('Do MMMM YYYY')}}</span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 no-gutters" >
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">{{$t('prof_currency')}}</span>
                                        <span class="currencyImage">
                                            <img :src="'../../../../static/fxView/images/'+getUserProfile.currency.toLowerCase()+'.svg'" class="mr-2" v-if="getUserProfile.currency">
                                            {{getUserProfile.currency || '-'}}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_emailaddress')}}</span>
                                        <span>{{getUserProfile.email}}</span>
                                    </div>
                                </div>
                                <!-- <div class="col-md-4">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('gender')}}</span>
                                        <span>{{genderList[getUserProfile.gender]}}</span>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0" v-if="parseInt(get_user.account_type) == 0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">{{$t('prof_PEP')}}</span>
                                         <span>{{(getUserProfile.pep)?'Yes':'No'}}</span> 
                                    </div>
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p">US person</span>
                                         <span>{{(getUserProfile.us_person)?'Yes':'No'}}</span>
                                    </div>
                                </div>
                            </div>
                           
                        </div> 
                        <div class="personalFormArea list-group" v-if="tab == 'address'"> 
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_addressLine1')}}</span>
                                        <span>{{getUserProfile.address1 || '-'}}</span>
                                    </div> 
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_addressLine2')}}</span>
                                        <span>{{getUserProfile.address2 || '-'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0"> 
                                    <div class="list-group-item">
                                        <span class="Fname d-block light-p"> {{$t('prof_postCode')}}</span>
                                        <span>{{getUserProfile.post_code || '-'}}</span>
                                    </div> 
                                </div>
                                <div class="col-md-6 col-12 pr-md-0 pl-md-2">
                                    <div class="list-group-item" >
                                        <span class="Fname d-block light-p"> {{$t('prof_city')}}</span>
                                        <span>{{(getUserProfile.city)?getUserProfile.city:'-'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 no-gutters">
                                <div class="col-md-6 col-12 pr-md-2 pl-md-0" v-if="getUserProfile.residence_country">
                                    <div class="list-group-item" v-for="clist in countriesList" v-if="clist.iso2 == getUserProfile.residence_country">
                                        <span class="Fname d-block light-p"> {{$t('prof_resCountry')}}</span>
                                        <span>{{clist.name || '-'}}</span>
                                    </div>
                                </div>
                            </div> 
                        </div> 
                        <div class="personalFormArea list-group mb-4" v-if="tab == 'bank'">
                            <div v-if="parseInt(get_user.verified_status) == 1">
    							<div v-if="getUserProfile.banks.length > 0">
    								<div v-for="(bankList,index) in getUserProfile.banks">
    									<div class="mb-3" v-if="parseInt(bankList.method) == 1">
                                            <div class="list-group-item d-flex justify-content-between align-items-center  p-4">
                                                <div>
                                                    <p class="mr-3 mb-0">
                                                        <strong> {{$t('prof_bankName')}}</strong>
                                                        <span v-html="(bankList.bank_name != '' && bankList.bank_name != null)? bankList.bank_name : '-'"></span>
                                                    </p>
                                                    <p class=" mb-0">
                                                        <strong> {{$t('prof_AccNumber')}}</strong>
                                                        <span v-html="(bankList.account_no != '' && bankList.account_no != null)? bankList.account_no : '-'"></span>
                                                    </p>
                                                </div>  
    											<div>
                                                    <a href="#" class="green " v-if="parseInt(bankList.status) == 2">{{$t('prof_Pending')}}</a>
                                                    <a href="#" class="green" @click.prevent="disable(bankList );" v-else>{{$t('prof_Disable')}}</a>
                                                    <a href="#" class="darkBG ml-3 viewDetail" @click.prevent="detailDiv(index);">{{$t('prof_viewDetail')}}</a>
                                                    
                                                </div>
                                            </div>
    										<div class="bottomInfo hide" :ref="'buttons'+index">
                                                <div class="list-group-item">
                                                    <span> {{$t('prof_paymentMethod')}}</span>
                                                    <span><img class="ml-2" :src="'../../../../static/fxView/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
                                                </div>  
                                                <div class="list-group-item">
                                                    <span> {{$t('prof_AccountName')}}</span>
                                                    <span v-html="(bankList.holder_name != '' && bankList.holder_name != null)? bankList.holder_name : '-'"></span>
                                                </div>
                                                <div class="list-group-item">
                                                    <span>{{$t('prof_SwiftCode')}}</span>
                                                    <span v-html="(bankList.sort_code != '' && bankList.sort_code != null)? bankList.sort_code : '-'"></span>
                                                </div>
                                                <div class="list-group-item">
                                                    <span>{{$t('prof_IBAN')}}</span>
                                                    <span v-html="(bankList.micr != '' && bankList.micr != null)? bankList.micr : '-'"></span>
                                                </div>
                                                <div class="list-group-item">
                                                    <span> {{$t('prof_bankAdd')}}</span>
                                                    <span v-html="(bankList.bank_address != '' && bankList.bank_address != null)? bankList.bank_address : '-'"></span>
                                                </div>                               
                                            </div>  
    									</div> 
    									<div class="mb-3" v-else-if="parseInt(bankList.method) == 2">
                                            <div class="list-group-item head align-items-center p-0 d-flex justify-content-between"> 
                                                <div class="d-flex justify-content-start align-items-center">
                                                    <p class="mr-3 border-right p-3 text-center">
                                                        <span><img   :src="'../../../../static/fxView/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>

                                                        <small> {{$t('prof_paymentMethod')}}</small>
                                                    </p> 
                                                    <p>
                                                        <strong>{{$t('prof_onlinePayId')}}</strong>
                                                        <span>{{bankList.online_payment_id}}</span>
                                                    </p>
                                                    
                                                </div>
    											<div class="p-3">
                                                    <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'2'}}">{{$t('prof_Change')}}</router-link>
                                                </div>
                                            </div> 
    									</div>
    									<div class="mb-3" v-else-if="parseInt(bankList.method) == 3">
                                            <div class="list-group-item head align-items-center p-0 d-flex justify-content-between"> 
                                                <div class="d-flex align-items-center justify-content-start">
                                                    <p class="mr-3 border-right p-3 text-center">
                                                        <span><img   :src="'../../../../static/fxView/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
                                                       
                                                        <small> {{$t('prof_paymentMethod')}}</small>

                                                    </p>
                                                    <p class="mr-3">
                                                        <strong>{{$t('prof_onlinePayId')}}:</strong>
                                                        <span>{{bankList.online_payment_id}}</span>
                                                    </p> 
                                                </div> 
    											<div class="p-3">
                                                    <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'3'}}">{{$t('prof_Change')}}</router-link>
                                                </div>
                                            </div> 
    									</div>	
    									<div class="mb-3" v-else-if="parseInt(bankList.method) == 5">
                                            <div class="list-group-item head align-items-center p-0 d-flex justify-content-between"> 
                                                <div class="d-flex align-items-center justify-content-start">
                                                    <div class="mr-3 border-right p-3 text-center">
                                                        <span class="mb-3"><img   :src="'../../../../static/fxView/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account" class="Account"></span> 
                                                        <small> {{$t('prof_paymentMethod')}}</small>
                                                    </div>
                                                    <div class="py-3">
                                                        <p class="mb-2">
                                                            <strong>{{$t('prof_CreditCard')}}</strong>
                                                            <span> **** **** **** {{bankList.last_digit_card}}</span>
                                                        </p>
                                                        <p class="mb-2">
                                                            <strong>{{$t('prof_ExpiryDate')}}</strong>
                                                            <span> {{bankList.card_month}}/{{bankList.card_year}}</span> 
                                                        </p>
                                                    </div>
                                                </div> 
    											<div class="p-3">
    												<a href="#" class="green" v-if="parseInt(bankList.status) == 2">{{$t('prof_Pending')}}</a>
                                                    <a href="#" class="green" @click.prevent="disable(bankList );" v-else>{{$t('prof_Disable')}}</a>
                                                </div>
                                            </div> 
    									</div>
    																	
    								</div>
    							</div>
                                <div class="list-group mb-4" v-else>
                                    <div class="list-group-item noBankDetail text-center py-4 border-0 text-center d-flex justify-content-center align-items-center">
                                        <div class="text-center">
                                            <figure class="mb-3 detailsFigure">
                                               <img src="../../../../static/fxView/images/bank.svg" alt="bank">
                                            </figure>
                                            <p class="mb-0"> {{$t('prof_noBankDetail')}}</p>
                                        </div>
                                    </div> 
                                </div>
    							<div class="addBank text-center mt-3" >
    								<router-link  class= "prism_btn darkBG mr-3" :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}">{{$t('prof_AddBank')}}</router-link>
    								
    							</div>
                            </div>
                            <no-trading-account :demo_live_both="''" :totalRecords = "'0'" v-else></no-trading-account>

                        </div> 
                        
                        
                        <div class="personalFormArea list-group  documentsListOuter" v-if="tab == 'doc'">
                        
                            <div class="documentsList" v-if="getUserProfile.documents.length > 0">
                                <div class="d_list" v-for="doc_list in getUserProfile.documents">
                                    <p v-if="doc_list.document_type != undefined && doc_list.document_type != '' && doc_list.document_type != null">{{doc_list.document_type}}</p>
                                    <a :href="$env_var.docsLink+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()" v-if="doc_list.extension == 'pdf' || doc_list.extension == 'PDF' || doc_list.extension == 'application/pdf' || doc_list.extension == 'application/PDF'">
                                        <iframe :src = "$env_var.docsLink+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()"></iframe>
                                    </a> 
                                    <a :href="$env_var.docsLink+getUserProfile.id+'&doc='+ doc_list.document" target="_blank()" v-else>
                                        <img :src="$env_var.docsLink+getUserProfile.id+'&doc='+ doc_list.document" />
                                    </a>
                                </div>
                            </div>
                            <div class="twoBlock list-group mb-4 text-center" v-else>                                
                                <div class="list-group-item text-center">
                                    <span></span>
                                    <span> {{$t('prof_noDocuments')}}</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>

                        <div class="personalForm  mb-4" v-if="tab == 'trading'">
                            <div class="max-custom">
                                <div class="linkAccount space text-center">
                                    <!-- <label class="main-content-label tx-13 font-weight-bold mb-0">Link your trading account</label>
                                    <div class="form-group field-wrapper mt-2 position-relative">
                                        <input placeholder=" " type="text" name="amount" class="float-field form-control" aria-required="true" aria-invalid="false"> 
                                        <label class="float-label">Trading Account</label>
                                        <div class="bottomBtn space d-flex align-items-center justify-content-end">
                                           <a href="#" class="prism_btn btn_sm">Link</a>
                                        </div> 
                                    </div> -->
                                    <router-link  class= "prism_btn darkBG mr-3 py-0" :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '171','method_id':'173'}}">{{$t('profileReq_tradingHeading')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
		
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import optVerfication from '../supports/services/otp_verification'
    import moment from 'moment'
    export default {
        name: 'profile',
        mixins: [fxViewMixins],
        data() {
            return {
				tab : 'basic',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                loaderFuncRun : '1',
				trans_id : '',
				Title : ''
            }
        },
		components: {
            appOptVerfication : optVerfication
        },
		methods:{
           
			detailDiv(index) {
                if ($(this.$refs['buttons'+index]).hasClass('hide')){
                    $(this.$refs['buttons'+index]).removeClass('hide');
                }else{
                    $(this.$refs['buttons'+index]).addClass('hide');
                }                
            },
			getUserProfileFunc(){
				 this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : this.loaderFuncRun}})
			},
			disable(getData){
				let message = ''
				if(parseInt(getData.method) == 5){
					message = this.$t('prof_disablecard')+ "\n" +this.$t('prof_creditcardno')+ getData.last_digit_card + "\n" + this.$t('prof_ExpiryDate')+ getData.card_month +"/"+ getData.card_year
				}else{
					message = this.$t('prof_bankpaymentmethod')+ "\n" +  this.$t('prof_AccNumber')+ getData.account_no 
				}
				this.Title = 112
				let jsonData = {
					'globalParams' :{
						"method_id": getData.id ,
						"method" : getData.method,
						"subject": this.$t('prof_diablepaymentmethod'),
						"text": message,
						"reason": 16,
						"reason_text": this.$t('prof_addpeymentmethod'),
						"title": 112,
						"title_text": this.$t('prof_diablepaymentmethod'),
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTicketRequestOtp(jsonData)
			}
		},
        created(){ 
            if(this.$store.getters[Const.GET_USER_PROFILE] != ''){
                this.loaderFuncRun = '0'
            }

            if(this.$route.query.tab){
                this.tab = this.$route.query.tab 
                this.$router.replace({query: null})
            }
            this.getUserProfileFunc()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/profile.vue